/**
 * ============================================================================
 * useKbSearchPagesForLink — Busca artigos do tenant para o picker de link
 *                           entre artigos. Debounce implícito via staleTime.
 *
 * CHANGELOG:
 *   RELEASE: 2026-07-08 v1.0.0 - Versão inicial.
 * ============================================================================
 */
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { logger } from "@/lib/logger";

export interface KbLinkSearchResult {
  page_id: string;
  space_id: string;
  space_name: string;
  collection_id: string | null;
  collection_name: string | null;
  title: string;
  slug: string;
  status: string;
  updated_at: string;
}

export function useKbSearchPagesForLink(
  query: string,
  spaceId?: string | null,
  limit = 15,
) {
  const trimmed = (query ?? "").trim();
  return useQuery({
    queryKey: ["kb", "search-pages-for-link", trimmed, spaceId ?? "all", limit],
    staleTime: 10_000,
    queryFn: async (): Promise<KbLinkSearchResult[]> => {
      const { data, error } = await supabase.rpc("kb_search_pages_for_link", {
        p_query: trimmed,
        p_space_id: spaceId ?? null,
        p_limit: limit,
        p_tenant_hint: null,
      });
      if (error) {
        logger.error("[useKbSearchPagesForLink]", "falha na busca", error);
        throw error;
      }
      return (data ?? []) as KbLinkSearchResult[];
    },
  });
}
